<div *ngIf="!brandingStatus && premiumRequired" class="alert alert-warning border-warning mb-2 default-font-size"
    [ngClass]="{'disabled': !brandingEditable }" role="alert">
    <span translate="Settings.OrganisationBrandingSection.TabGeneralInformation"></span>
</div>
<div *ngIf="premiumRequired" class="mb-3 mt-1 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
    <div class="d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="setBrandingStatus"
            name="setBrandingStatus" [(ngModel)]="brandingStatus" (click)="setBrandingStatus()"
            [disabled]="!brandingEditable">
        <label class="form-check-label pt-1 col-10" for="authenticatorapp"
            translate="Settings.OrganisationBrandingSection.EnableProductionMode"></label>
    </div>
</div>
<form >
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.PlatformURL"><app-info-button labelName="Settings.OrganisationBrandingSection.PlatformUrlTooltip"></app-info-button></label>
        <input type="text" id="frmField" [formControl]="domainUrlControl" [disabled]="!isUserAllowedToEditUrl" class="form-control" value="{{generalBranding?.frontendDomain}}" (keyup)="updateValues('frontendDomain',$event)" (focusout)="updateValues('frontendDomain',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.PlatformURL' | translate }}">
        <app-formcontrol-error-messages [forControl]="domainUrlControl"></app-formcontrol-error-messages>
    </div>
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.IdentityURL"><app-info-button labelName="Settings.OrganisationBrandingSection.IdentityUrlTooltip"></app-info-button></label>
        <input type="text" id="frmField" [formControl]="identityUrlControl" [disabled]="!isUserAllowedToEditUrl" class="form-control" value="{{generalBranding?.identityDomain}}" (keyup)="updateValues('identityDomain',$event)" (focusout)="updateValues('identityDomain',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.IdentityURL' | translate }}">
        <app-formcontrol-error-messages [forControl]="identityUrlControl"></app-formcontrol-error-messages>
        </div>
    <div class="col-12 text-end">
        <button type="submit" class="btn btn-sm btn-primary" (click)="updateUrls()" translate="Button.SaveChangesUrl" *ngIf="isUserAllowedToEditUrl"></button>
     </div>
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.PlatformName"><app-info-button labelName="Settings.OrganisationBrandingSection.PlatformNameTooltip"></app-info-button></label>
        <input type="text" id="frmField" class="form-control" [disabled]="!brandingEditable" value="{{generalBranding?.organisationName}}" (keyup)="updateValues('organisationName',$event)" (focusout)="updateValues('organisationName',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.PlatformName' | translate }}">
    </div>
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.SenderEmailAddress"><app-info-button labelName="Settings.OrganisationBrandingSection.EmailFromTooltip"></app-info-button></label>
        <input type="text" id="frmField" class="form-control" value="{{generalBranding?.mailAddressSender}}" (keyup)="updateValues('mailAddressSender',$event)" (focusout)="updateValues('mailAddressSender',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.SenderEmailAddress' | translate }}" [disabled]="!brandingEditable">
    </div>
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.SenderSMSName"><app-info-button labelName="Settings.OrganisationBrandingSection.SenderSmsTooltip"></app-info-button></label>
        <!-- A HEADER THAT NOTIFIES WHEN EXCEEDING LENGTH OF SMS NAME, this is NOT blocking. but it is good to show the user that it happens-->
        <ng-container *ngIf="doesSmsSenderNameExceedLimit">
            <div  class="alert alert-warning border-warning mb-2 default-font-size" role="alert">
                <span  translate="Settings.OrganisationBrandingSection.WarningForSmsNameLengthNotify"></span>
                <br/>
                <span  translate="Settings.OrganisationBrandingSection.WarningForSmsNameLengthDescription"
                [translateParams]="{currentLength:getLengthOfSmsSenderName,receiverName: cutShortSmsName}"></span>
            </div>            
        </ng-container>
        <input type="text" id="frmField" class="form-control" value="{{generalBranding?.smsSenderName}}" (keyup)="updateValues('smsSenderName',$event)" (focusout)="updateValues('smsSenderName',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.SenderSMSName' | translate }}" [disabled]="!brandingEditable">
    </div>
    <div class="mb-3 col-12">
        <label for="frmField" class="form-label" translate="Settings.OrganisationBrandingSection.TermsAndConditionsURL"><app-info-button labelName="Settings.OrganisationBrandingSection.TermsAndConditionsTooltip"></app-info-button></label>
        <input type="text" id="frmField" class="form-control" value="{{generalBranding?.termsAndConditionsUrl}}" (keyup)="updateValues('termsAndConditionsUrl',$event)" (focusout)="updateValues('termsAndConditionsUrl',$event)" placeholder="{{ 'Settings.OrganisationBrandingSection.TermsAndConditionsURL' | translate }}" [disabled]="!brandingEditable">
    </div>
    <div class="col-12 text-end">
        <button type="submit" class="btn btn-sm btn-primary" (click)="updateBrandingGeneral()" translate="Button.SaveChanges"  [disabled]="!brandingEditable"></button>
    </div>
</form>

<span class="col-12 mt-3 d-block" translate="Settings.OrganisationBrandingSection.Options"></span>

<!-- Enable knowledge base -->
<div class="mt-1 mx-0 p-1 col-12 row text-wrap border rounded-top lh-base">
    <div class="col-9 d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="enableKnowledgebase" name="enableKnowledgebase" (click)="updateToggleSwitches('knowledgebase',$event)"  [(ngModel)]="knowledgebase" [disabled]="!brandingEditable">
        <label class="form-check-label pt-1 col-10" for="enableKnowledgebase" translate="Settings.OrganisationBrandingSection.EnableKnowledgebase">
            <app-info-button labelName="Settings.OrganisationBrandingSection.EnableKnowledgebaseTooltip"></app-info-button>
        </label>
    </div>
    <div *ngIf="knowledgebase" class="col-3 pe-2 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="openCustomUrlsAvatarMenuKnowledgebaseModal()"></a></li>
            </ul>
        </div>
    </div>
</div>

<!-- Enable support -->
<div class="mx-0 p-1 col-12 row text-wrap border lh-base">
    <div class="col-9 d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="enableSupport" name="enableSupport" (click)="updateToggleSwitches('support',$event)"  [(ngModel)]="support" [disabled]="!brandingEditable">
        <label class="form-check-label pt-1 col-10" for="enableSupport" translate="Settings.OrganisationBrandingSection.EnableSupport">
            <app-info-button labelName="Settings.OrganisationBrandingSection.EnableSupportTooltip"></app-info-button>
        </label>
    </div>
    <div *ngIf="support" class="col-3 pe-2 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="openCustomUrlsAvatarMenuSupportModal()"></a></li>
            </ul>
        </div>
    </div>
</div>

<!-- Enable release notes -->
<div class="mx-0 p-1 col-12 row text-wrap border lh-base">
    <div class="col-9 d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="enableReleaseNotes" name="enableReleaseNotes" (click)="updateToggleSwitches('releasenotes',$event)"  [(ngModel)]="releasenotes" [disabled]="!brandingEditable">
        <label class="form-check-label pt-1 col-10" for="enableReleaseNotes" translate="Settings.OrganisationBrandingSection.EnableReleaseNotes">
            <app-info-button labelName="Settings.OrganisationBrandingSection.EnableReleaseNotesTooltip"></app-info-button>
        </label>
    </div>
    <div *ngIf="support" class="col-3 pe-2 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="openCustomUrlsAvatarMenuReleaseNotesModal()"></a></li>
            </ul>
        </div>
    </div>
</div>

<!-- WhatsApp -->
<div class="mx-0 p-1 col-12 row text-wrap border rounded-bottom lh-base">
    <div class="col-9 d-table form-check form-switch">
        <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch"
            id="enablePrivateWhatsapp" name="enablePrivateWhatsapp" (click)="toggleWhatsapp()"
            [(ngModel)]="enablePrivateWhatsapp" [disabled]="!brandingEditable">
        <label class="form-check-label pt-1 col-10" for="enablePrivateWhatsapp"
            translate="Settings.OrganisationBrandingSection.EnablePrivateWhatsapp">
            <app-info-button
                labelName="Settings.OrganisationBrandingSection.EnablePrivateWhatsappTooltip"></app-info-button>
        </label>
    </div>

    <div *ngIf="enablePrivateWhatsapp" class="col-3 pe-2 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="editPrivateWhatsapp()"></a></li>
            </ul>
        </div>
    </div>
</div>